"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2Constansts = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcMenuV2Constansts = (function () {
    function BcMenuV2Constansts() {
    }
    BcMenuV2Constansts.BC_MENU_V2_BACKGROUND_COLOR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-bg-brand-P-N-pair-01-900");
    BcMenuV2Constansts.BC_MENU_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2");
    BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-type-function");
    BcMenuV2Constansts.BC_MENU_V2_FOOTER_STROKE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-footer-stroke");
    BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS_MORE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-item-more");
    BcMenuV2Constansts.BC_MENU_V2_LOGOUT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-logout-menu-v2");
    BcMenuV2Constansts.BC_MENU_V2_LOGOUT_RESPONSIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-logout-responsive-menu-v2");
    BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list-items-menu-v2");
    BcMenuV2Constansts.BC_MENU_V2_ITEM_MORE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-item-menu-v2-more");
    BcMenuV2Constansts.BC_MENU_V2_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-content");
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER_TABLET = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-pop-over-menu-v2-tablet");
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MOBILE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-pop-over-menu-v2-mobile");
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-pop-over-menu-v2");
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE = 'pop-over-menu-more';
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2 = 'pop-over-menu-v2';
    BcMenuV2Constansts.BC_MENU_V2_POP_OVER_DISPLAY = 'display: none;';
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_MINIMAL_UNBORDERED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-minimal-unbordered");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TEXT_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-text-container");
    BcMenuV2Constansts.BC_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-header");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_HEADER_RIGHT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-header-right");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_HEADER_LEFT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-header-left");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-title");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TOGGLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-toggle-button");
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE_SUPER_BASIC = 'accordion-title-super-basic-wob';
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_ALT = 'Flecha hacia abajo para abrir el acordeón';
    BcMenuV2Constansts.BC_MENU_V2_ACCORDION_WITHOUT_HEADER = 'without-border-header';
    BcMenuV2Constansts.BC_MENU_V2_ICON_ARROW_RIGHT = 'arrow3-right';
    BcMenuV2Constansts.BC_MENU_V2_WEBKIT = '-webkit-fill-available';
    BcMenuV2Constansts.BC_MENU_V2_SECONDARY_MENU = 'secondary-menu';
    BcMenuV2Constansts.BC_MENU_V2_COLAPSE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-colapse");
    BcMenuV2Constansts.BC_MENU_V2_MARGIN_TABLET = "0px 32px 0px 32px";
    BcMenuV2Constansts.BC_MENU_V2_BOX_SHADOW_ACCORDION = "0 0 0 0";
    BcMenuV2Constansts.BC_MENU_V2_PADDING = "16px 32px 16px 32px";
    BcMenuV2Constansts.BC_MENU_V2_HEIGHT_HEADER = 'calc(100vh - 90px)';
    BcMenuV2Constansts.BC_MENU_V2_GROUPS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-groups");
    BcMenuV2Constansts.BC_MENU_V2_DEPLOY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-deploy");
    BcMenuV2Constansts.BC_MENU_V2_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-header");
    BcMenuV2Constansts.BC_MENU_V2_CLOSE_SESION = 'Cerrar Sesión';
    BcMenuV2Constansts.BC_MENU_V2_FIT_CONTENT = 'fit-content';
    BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE = 'data-toogle';
    BcMenuV2Constansts.BC_MENU_V2_ARIA = 'aria-labelledby';
    BcMenuV2Constansts.BC_MENU_V2_ICON_PREMIUM = 'premium';
    BcMenuV2Constansts.BC_MENU_V2_TOP_RIGHT = 'top-right';
    BcMenuV2Constansts.BC_MENU_V2_TOP_LEFT = 'top-left';
    BcMenuV2Constansts.BC_MENU_V2_LINK_SELF = '_self';
    BcMenuV2Constansts.BC_MENU_V2_RELATIVE = 'relative';
    BcMenuV2Constansts.BC_MENU_V2_ABSOLUTE = 'absolute';
    BcMenuV2Constansts.BC_MENU_V2_TABINDEX = 'tabindex';
    BcMenuV2Constansts.BC_MENU_V2_ICON_LOGIN = 'login';
    BcMenuV2Constansts.BC_MENU_V2_STROKE = 'bc-stroke';
    BcMenuV2Constansts.BC_MENU_V2_ATR_TITLE = 'title';
    BcMenuV2Constansts.BC_MENU_V2_ICON_QUIT = 'quit';
    BcMenuV2Constansts.BC_MENU_V2_ATR_ICON = 'icon';
    BcMenuV2Constansts.BC_MENU_V2_TOOGLE = 'toogle';
    BcMenuV2Constansts.BC_MENU_V2_STATIC = 'static';
    BcMenuV2Constansts.BC_MENU_V2_INHERIT = 'inherit';
    BcMenuV2Constansts.BC_MENU_V2_REGION = 'region';
    BcMenuV2Constansts.BC_MENU_V2_TARGET = 'target';
    BcMenuV2Constansts.BC_MENU_V2_FIXED = 'fixed';
    BcMenuV2Constansts.BC_MENU_V2_FIXED_HEADER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-fixed");
    BcMenuV2Constansts.BC_MENU_V2_FALSE = 'false';
    BcMenuV2Constansts.BC_MENU_V2_N600X = '600px';
    BcMenuV2Constansts.BC_MENU_V2_N500X = '500px';
    BcMenuV2Constansts.BC_MENU_V2_N450X = '450px';
    BcMenuV2Constansts.BC_MENU_V2_GROUP = 'group';
    BcMenuV2Constansts.BC_MENU_V2_N75VH = '75vh';
    BcMenuV2Constansts.BC_MENU_V2_AUTO = 'auto';
    BcMenuV2Constansts.BC_MENU_V2_BODY = 'body';
    BcMenuV2Constansts.BC_MENU_V2_TRUE = 'true';
    BcMenuV2Constansts.BC_MENU_V2_N90H = '90vh';
    BcMenuV2Constansts.BC_MENU_V2_N20H = '20vh';
    BcMenuV2Constansts.BC_MENU_V2_N28H = '28vh';
    BcMenuV2Constansts.BC_MENU_V2_N100 = '100%';
    BcMenuV2Constansts.BC_MENU_V2_N60X = '60px';
    BcMenuV2Constansts.BC_MENU_V2_N85P = '85%';
    BcMenuV2Constansts.BC_MENU_V2_N500 = '500';
    BcMenuV2Constansts.BC_MENU_V2_N16 = '16px';
    BcMenuV2Constansts.BC_MENU_V2_N85 = '85vh';
    BcMenuV2Constansts.BC_MENU_V2_TOP = 'top';
    BcMenuV2Constansts.BC_MENU_V2_MAS = 'Más';
    BcMenuV2Constansts.BC_MENU_V2_N95 = '95%';
    BcMenuV2Constansts.BC_MENU_V2_N90 = '90%';
    BcMenuV2Constansts.BC_MENU_V2_N80 = '80%';
    BcMenuV2Constansts.BC_MENU_V2_N79 = '79%';
    BcMenuV2Constansts.BC_MENU_V2_N75 = '75%';
    BcMenuV2Constansts.BC_MENU_V2_N70 = '70%';
    BcMenuV2Constansts.BC_MENU_V2_N60 = '60%';
    BcMenuV2Constansts.BC_MENU_V2_N10 = '10%';
    BcMenuV2Constansts.BC_MENU_V2_N0 = '0';
    BcMenuV2Constansts.BC_MENU_V2_PADDING_MOBILE = 20;
    BcMenuV2Constansts.BC_MENU_V2_PADDING_MOBILE_IOS = 2;
    BcMenuV2Constansts.BC_MENU_V2_N74 = 74;
    BcMenuV2Constansts.BC_MENU_V2_N991 = 991;
    BcMenuV2Constansts.BC_MENU_V2_N767 = 767;
    BcMenuV2Constansts.BC_MENU_V2_N768 = 768;
    BcMenuV2Constansts.BC_MENU_V2_SAFARI_REGEX = /^((?!chrome|android).)*safari/i;
    BcMenuV2Constansts.BC_SUBMENU_V2_DISABLED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-disabled");
    BcMenuV2Constansts.BC_SUBMENU_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-v2");
    BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-v2-active");
    BcMenuV2Constansts.BC_SUBMENU_V2_PRESS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-submenu-v2-press");
    BcMenuV2Constansts.BC_SUBMENU_V2_LABEL = 'Elemento expandible';
    BcMenuV2Constansts.BC_SUBMENU_V2_TEXT_BREAK = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-text-break");
    BcMenuV2Constansts.BC_MAIN_MENU_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-main-menu-v2");
    BcMenuV2Constansts.BC_MEGA_MENU_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2-container");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2-subgroup");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_CLOSE_BUTTON = ":scope>section>button";
    BcMenuV2Constansts.BC_MEGA_MENU_V2_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2-content");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2-active");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_ITEM = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mega-menu-v2-item");
    BcMenuV2Constansts.BC_MEGA_MENU_V2_3_BUTTON_CLOSE = 'Cerrar menú';
    BcMenuV2Constansts.BC_MEGA_MENU_V2_3_COLUMNS = '728px';
    BcMenuV2Constansts.BC_MEGA_MENU_V2_COLUMNS = '496px';
    BcMenuV2Constansts.BC_MEGA_MENU_V2_COLUMN = '264px';
    BcMenuV2Constansts.BC_MEGA_MENU_V2_BUTTON = '280px';
    BcMenuV2Constansts.BC_MEGA_MENU_V2_WITH = '264';
    BcMenuV2Constansts.BC_MENU_V2_LINE_CLAMP_N2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-item-line-clamp-2");
    BcMenuV2Constansts.BC_MENU_V2_LINE_CLAMP_N1 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-menu-v2-item-line-clamp-1");
    return BcMenuV2Constansts;
}());
exports.BcMenuV2Constansts = BcMenuV2Constansts;
